import { HttpError } from './HttpError';

/**
 * SessionError extends the error HttpError.
 */
export class InvalidSessionError extends HttpError {}
